import { Box, Button, Center, HStack, Heading, Image, Text } from "@chakra-ui/react";
import "@fontsource/roboto";
import { useMediaQuery } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom';



const PropertyCard = (props) => {
    const [isLgThan580] = useMediaQuery('(min-width: 580px)')
    let navigate = useNavigate();
    return (
       
            <Box w={isLgThan580 ? "346px": "246px"}  borderRadius="24px" fontFamily="Roboto" color="#1C3E64" border="2px solid #F0F0F0" >
                <Image borderTopRadius="24px" w="100%" height={isLgThan580 ? "194px": "138px"} src={props.data.images[0]} objectFit="cover" alt="" />
                <Box w="100%" bgColor="white" borderRadius="24px" p="18px">
                    <HStack pb="18px" borderBottom="1px solid rgba(28, 62, 100, 0.50)">
                        <Box >
                            <Heading color="#1D1B20" fontFamily="Roboto" fontSize="20px" fontWeight="400">{props.data.name}</Heading>
                        </Box>

                    </HStack>
                    <Box pt="18px" pb="36px" fontFamily="Roboto" fontSize={isLgThan580 ? "16px": "13px"}>
                        <HStack pb="8px" >
                            <Box w="78%" >
                                <Text  >Targeted Investor IRR:</Text>
                            </Box>
                            <Box w="22%" textAlign="right">
                                <Text >{props.data.performanceMetrics?.targetedInvestorIRR ? `${props.data.performanceMetrics?.targetedInvestorIRR}%` : "_"}</Text>
                            </Box>
                        </HStack>
                        <HStack pb="8px">
                            <Box w="78%" >
                                <Text >Targeted Average Cash Yield:</Text>
                            </Box>
                            <Box w="22%" textAlign="right">
                                <Text >{props.data.performanceMetrics?.targetedInvestorIRR ? `${props.data.performanceMetrics?.targetedAverageCashYield}%` : "_"}</Text>
                            </Box>
                        </HStack>
                        <HStack pb="8px" >
                            <Box w="70%" >
                                <Text >Targeted Equity Multiple:</Text>
                            </Box>
                            <Box w="30%" textAlign="right">
                                <Text>{props.data.performanceMetrics?.targetedInvestorIRR ? `${props.data.performanceMetrics?.targetEquity}x` : "_"}</Text>
                            </Box>
                        </HStack>
                        <HStack >
                            <Box w="78%" >
                                <Text >Minimum Investment:</Text>
                            </Box>
                            <Box w="22%" textAlign="right">
                                <Text >{props.data.minimumInvestment ? `$${props.data.minimumInvestment}` : "_"}</Text>
                            </Box>
                        </HStack>
                    </Box>

                    <HStack justifyContent="right">
                        <Button onClick={() => navigate(`/property/${props.data.id}`)} size='sm' border= "1px solid #002B5B" _hover={{  color: "#002B5B", bgColor: "transparent" }} color="#F0F0F0" fontFamily="Roboto" p={isLgThan580 ? "18px 24px": "8px 14px"} bgColor="#002B5B" borderRadius="200px" fontSize={isLgThan580?"14px":"10px"}>View Property</Button>
                    </HStack>

                </Box>

            </Box>
       
    );
}

export default PropertyCard;